import React, { Component } from 'react';
import { get } from 'axios';
import { message, Skeleton } from 'antd';
import { connect } from 'react-redux';

class FetchUserInfo extends Component {
  // componentDidMount() {
  //   if (
  //     this.props.token !== '' &&    // 有 token
  //     this.props.userInfo === null  // 并且没有获取过 userInfo
  //   ) {
  //     this.fetchInfo();
  //   }
  // }

  render() {
    const { userInfo, token } = this.props;

    if (userInfo === null && token !== '') {
      return <Skeleton avatar paragraph={{ rows: 4 }} active />
    } 

    return this.props.children({
      userInfo: this.props.userInfo,
      refreshUserInfo: this.fetchInfo,
      setUserInfo: this.props.setUserInfo,
    })
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.token !== this.props.token) {
  //     this.fetchInfo();
  //   }
  // }

  fetchInfo = async () => {
    try {
      const { data } = await get('user/get-info');
      if (data.error_code !== 0) {
        message.error(data.message);
      } else {
        this.props.setUserInfo(data.data);
      }
      
    } catch (err) {
      throw err;
    }
  }
}

const mapState = ({ userInfo, loginInfo }) => ({
  token: loginInfo.access_token,
  userInfo: userInfo,
});

const mapDispatch = ({ userInfo }) => ({
  setUserInfo: userInfo.setUserInfo,
});

export default connect(
  mapState,
  mapDispatch
)(FetchUserInfo);
